export const HTML_BASE_NAME = `${process.env.PUBLIC_URL.replace(/\/$/, '')}` || '';
export const LOCALES = {
  'pl-PL': {id: 'pl-PL', lang: 'pl', label: 'Polish', fetchDateFnsLocale: () => import('date-fns/locale/pl')}
};

// WARNING: changing this will reset everybody's default language settings
export const I18N_LS_KEY = 'i18nextLng';

